import { useLanguageContext } from '../../../contexts/LanguageContext';
import DefaultConstants from '../../../data/Constants';
import './style.scss';
import { Box, Grid, Typography } from '@mui/material';
import DateTimeHelper from '../../../helpers/DateTimeHelper';
import DefaultImages from '../../../data/Images';

const Copyright = () => {
    const { translate } = useLanguageContext();


    return <Box className='grid-content-section' id='copyright'>
        <Grid container rowSpacing={DefaultConstants.gridRowSpacing} columnSpacing={DefaultConstants.gridColumnSpacing}>
            <Grid item lg={6} md={6} xs={12} className='display-flex alignitems-center justifycontent-flexstart gap-32'>
                <img src={DefaultImages.full.colorful} alt={DefaultConstants.websiteName} className='image-logo' />

                <Typography variant='caption' className='text-enterprise display-flex flexdirection-column gap-6'> 
                    {DefaultConstants.commercialName}

                    <Typography variant='caption' className='text-enterprise text-document'> 
                        CNPJ {DefaultConstants.document}
                    </Typography>
                </Typography>
            </Grid>

            <Grid item lg={6} md={6} xs={12} className='display-flex flexdirection-column alignitems-flexend justifycontent-center gap-6 textalign-right'>
                <Typography variant='caption' className='text-copyright'> 
                    {translate("copyright").replace('{date}', DateTimeHelper.Now('YYYY'))}
                </Typography>

                <Typography variant='caption' className='text-developer' onClick={() => window.open(DefaultConstants.developer.link)}> 
                    {translate('developedBy')} {DefaultConstants.developer.name}
                </Typography>
            </Grid>
        </Grid>
    </Box>;
}

export default Copyright;